import * as Tone from 'tone'

Tone.getTransport().bpm.rampTo(100)

const pianoSampler = new Tone.Sampler({
	urls: {
		'C4': 'C4.mp3',
		'D#4': 'Ds4.mp3',
		'F#4': 'Fs4.mp3',
		'A4': 'A4.mp3',
	},
	baseUrl: 'https://tonejs.github.io/audio/salamander/',
}).toDestination();

const guitarSampler = new Tone.Sampler({
	urls: {
		'G4': '8403_6479-lq.mp3',
		'E3': '8397_6479-lq.mp3',
		'E4': '8394_6479-lq.mp3',
	},
	baseUrl: 'https://freesound.org/data/previews/8/',
}).toDestination();

const synth = new Tone.PolySynth(Tone.Synth).toDestination();

const soundsDico = {
	'synth': synth,
	'piano': pianoSampler,
	'guitar': guitarSampler
}

export const playNotes = (notes: any[], sound: string = 'synth') => {
	console.log({ playNotes: notes })

	// @ts-ignore
	const instrument = soundsDico[sound]
	if (!instrument || (sound !== 'synth' && !instrument.loaded)) return

	// const now = Tone.now()
	for (let i = 0; i < notes.length; i++) {
		instrument.triggerAttackRelease(notes[i].name, notes[i].duration, notes[i].delay)
	}
}

export const playSequence = (steps: any[], bpm = 60, sound: string = 'synth') => {

	// @ts-ignore
	const instrument = soundsDico[sound]
	if (!instrument || (sound !== 'synth' && !instrument.loaded)) return


	console.log({ playSequence: steps })

	Tone.Transport.bpm.value = bpm

	// const seq = new Tone.Sequence((time, note) => {
	// 	synth.triggerAttackRelease(note, 0.1, time);
	// 	// subdivisions are given as subarrays
	// }, ["C4", ["E4", "D4", "E4", "E4"], "G4", ["A4", "G4"]]).start(0);
	// Tone.Transport.start();

	const part = new Tone.Part(((time, note) => {

		console.log({ note, time })

		// the notes given as the second element in the array
		// will be passed in as the second argument
		instrument.triggerAttackRelease(note.name, note.duration, time, note.velocity)
	}), steps).start(0)//[["0:0", "C2"], ["0:2", "C3"], ["0:3:2", "G2"]]);

	part.loopStart = '0:0'
	part.loopEnd = '32:0'
	part.loop = 2

	Tone.Transport.start()
	// setTimeout(() => Tone.Transport.start(), 500);

	// setTimeout(() => Tone.Transport.stop(), 6000)
}

export default {
	playNotes
}